var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymce"},[_c('editor',{attrs:{"id":"tinymce","init":_vm.init},model:{value:(_vm.tinymceHtml),callback:function ($$v) {_vm.tinymceHtml=$$v},expression:"tinymceHtml"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }